import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import KipLibrary from './components/KipLibrary';
import ScenarioDetail from './components/ScenarioDetail';
import KipPlayer from './components/KipPlayer';
import KipReport from './components/KipReport';
import Profile from './components/Profile';
import PersonasPage from './components/PersonasPage';
import ElevenLabsTest from './components/ElevenLabsTest';
import ExplainerPage from './components/ExplainerPage';
import DemoLandingPage from './components/DemoLandingPage';
import Login from './components/Login';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import NotFound from './components/NotFound';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import AdminDashboard from './components/admin/AdminDashboard';

/** Preserves query string so Stripe checkout success (?checkout=success) lands on Profile. */
function BillingToProfileRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/profile${search}`} replace />;
}

function App() {
  const showDevRoutes = import.meta.env.DEV || import.meta.env.VITE_ENABLE_TEST_ROUTES === 'true';

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/demo" element={<DemoLandingPage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="library" element={<KipLibrary />} />
          <Route path="scenario/:id" element={<ScenarioDetail />} />
          <Route path="report/:id" element={<KipReport />} />
          <Route path="profile" element={<Profile />} />
          <Route path="billing" element={<BillingToProfileRedirect />} />
          <Route path="personas" element={<PersonasPage />} />
          {showDevRoutes && <Route path="test-elevenlabs" element={<ElevenLabsTest />} />}
          <Route path="admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
        </Route>
        <Route path="player/:id" element={<ProtectedRoute requireTrainingAccess><KipPlayer /></ProtectedRoute>} />
        <Route path="explained" element={<ExplainerPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;